import React from "react";
import { UserX } from "lucide-react";
import { hasLeftCompany, formatDate } from "../../lib/utils";

const REASON = { deleted: "compte Microsoft 365 supprimé", disabled: "compte Microsoft 365 désactivé" };

export function LeftCompanyBadge({ user, size = "sm", className = "", testId }) {
    if (!hasLeftCompany(user)) return null;
    const cls = size === "xs" ? "text-[9px] px-1.5 py-0.5" : "text-[10px] px-2 py-0.5";
    return (
        <span className={`inline-flex items-center gap-1 rounded-full font-semibold bg-rose-100 text-rose-700 border border-rose-200 whitespace-nowrap ${cls} ${className}`}
            title={`A quitté l'entreprise${user.left_company_at ? ` — ${formatDate(user.left_company_at)}` : ""} (${REASON[user.entra_status] || "compte inactif"})`}
            data-testid={testId || `left-company-badge-${user.id}`}>
            <UserX className={size === "xs" ? "w-2.5 h-2.5" : "w-3 h-3"} />A quitté l'entreprise
        </span>
    );
}

export function LeftCompanyBanner({ user, context = "collaborateur", className = "" }) {
    if (!hasLeftCompany(user)) return null;
    return (
        <div className={`flex items-start gap-3 px-4 py-3 rounded-lg border border-rose-200 bg-rose-50 text-rose-800 ${className}`} role="status" data-testid="left-company-banner">
            <UserX className="w-5 h-5 flex-shrink-0 mt-0.5" />
            <div className="text-sm">
                <p className="font-semibold">Ce {context} a quitté l'entreprise</p>
                <p className="text-xs text-rose-700 mt-0.5">
                    {REASON[user.entra_status] ? REASON[user.entra_status].charAt(0).toUpperCase() + REASON[user.entra_status].slice(1) : "Compte inactif"}
                    {user.left_company_at ? ` — dernière présence constatée le ${formatDate(user.left_company_at)}` : ""}.
                    {" "}La fiche et tout l'historique sont conservés définitivement pour le suivi.
                </p>
            </div>
        </div>
    );
}
